import {removeAllToasts, showToast} from '../ToastContext';

export const useShowToast = () => showToast;
export const useRemoveAllToasts = () => removeAllToasts;
